export default {
  avatarStyle: {
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
    borderRadius: 20
  },
  textStyle: {
    color: "#fff",
    fontSize: 16,
    backgroundColor: "transparent",
    fontWeight: "100"
  }
};